import React, { useEffect, useState, useMemo } from 'react'
import WorkflowPhasesPage from '../../../Operations/Scenes/Workflows/Components/WorkflowPhasesPage';
import GetWorkflowMainCategoryService from '../../../../../../Service/OPSServices/WorkflowsService/GetWorkflowMainCategoryService';
import { connect } from 'react-redux';
import WorkflowIcon from '../../../../../../../src/designUtils/ProjectDashboard/WorkflowIcon.svg';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from "reactstrap";

export const ProactiveWorkflowsDropDownOption = (props) => {

  const [selectedItem, setSelectedItem] = useState(null)

  const selectedName = selectedItem !== null && props.buttons && props.buttons[selectedItem]
    ? props.buttons[selectedItem].name
    : "";

  return (
    <div className={`workflow-sidebar-section ${props.class || ''}`}>
      
    <div className="d-flex align-items-center mb-2 project-dashboard-sidebar cursor-pointer">
      
      <img 
        src={WorkflowIcon} 
        alt="Workflow" 
        className="project-dashboard-sidebar-icon mr-2" 
      />
      <UncontrolledButtonDropdown className="w-100" style={{ minWidth: 0 }}>
          
          <DropdownToggle 
            tag="div" 
            className="p-0 border-0 bg-transparent text-left" 
            style={{ cursor: 'pointer' }} 
          >
            <div className="d-flex align-items-center" style={{ fontWeight: 450, fontSize: '0.9rem', color: '#337ab7' }}>
              {/* <h5 ></h5> */}
              Workflows : 
              <span className="dropdown-toggle ml-1" style={{ border: 'none', marginTop: '4px' }}></span>
            </div>

            {selectedName && (
              <div 
                className="text-truncate mt-1" 
                style={{ maxWidth: '140px', color: '#337ab7', fontSize: '0.9rem' }} 
                title={selectedName} 
              >
                {selectedName}
              </div>
            )}
          </DropdownToggle>

          <DropdownMenu 
            container="body" 
            positionFixed={true}
            className="dropdown-menu-left shadow"
            style={{ zIndex: 9999, maxWidth: '300px' }}
          >
            {(props.buttons || []).map((item, index) => (
              <DropdownItem
                key={item.id}
                active={selectedItem === index}
                title={item.name}
                className="text-truncate" 
                style={{ maxWidth: '270px' }} 
                onClick={() => {
                  setSelectedItem(index);
                  props.handleWorkflowChange && props.handleWorkflowChange(item);
                }}
              >
                {item.name}
              </DropdownItem>
            ))}
          </DropdownMenu>

        </UncontrolledButtonDropdown>

    </div>
    </div>
  )
}

function ProjectsDashWorkFlowsMainPage(props) {
    const [workflowPhasesList,setWorkflowPhasesList]=useState()
    const [workflowMainCategory, setWorkflowMainCategory] = useState("");

    // const [selectedStoreData, setSelectedStoreData] = useState({
    //     integerId: "",
    //     storeName: "",
    //   });
      const selectedStoreData = useMemo(() => {
        return {
          integerId: props.selectedProjectData &&props.selectedProjectData.integerId || '',
          storeName: props.selectedProjectData &&props.selectedProjectData.storeName || ''
        };
      }, [props.selectedProjectData]);
    useEffect(()=>{
        console.log(props.selectedProjectData);
        // setSelectedStoreData({integerId:props.selectedProjectData.integerId,
        //     storeName:props.selectedProjectData.storeName
        //     }
        // )
        GetWorkflowMainCategoryService(props.token).then((res)=>{
            console.log(res);
            setWorkflowMainCategory(res.masterWorkflows);
            // const filteredPhases = res.workflowPhases && res.workflowPhases.filter(phase => phase.WorkflowsMaster == props.selectedProjectData.workflowsId).sort((a, b) => a.id - b.id);
          
            let workflowIds = props.selectedProjectData &&props.selectedProjectData.workflowsId;

        // convert to array safely
        if (!Array.isArray(workflowIds)) {
            workflowIds = workflowIds ? [workflowIds] : [];
        }

        const filteredPhases =
            res.workflowPhases &&
            res.workflowPhases
                .filter(phase =>
                    workflowIds.includes(phase.WorkflowsMaster)
                )
                .sort((a, b) => a.id - b.id);

        setWorkflowPhasesList(filteredPhases);

        console.log(filteredPhases);

     
        })

    },[])
  return (

  <>
  <div className="ml-3">
    <WorkflowPhasesPage 
    flag={false}
    selectedWorkflowMasterId={props.selectedWorkflowMasterId}
    workflowPhases={workflowPhasesList}
    selectedProjectData={props.selectedProjectData}
    workflowMainCategory={workflowMainCategory}
    selectedStoreData={selectedStoreData}
    key={workflowPhasesList}
    hideBackButton={true}
    />
  </div>
  </>
  )
}
const mapStateToProps = state => {
    return {
      token: state.loggedUser.token,
      accessLevel: state.loggedUser.accessLevel,
      status: state.loggedUser.status,
    }
  }
  
  export default connect(mapStateToProps)(ProjectsDashWorkFlowsMainPage);
